import _ from 'lodash'
import Constants from '@/utils/Constants'

const state = {
  isInit: false,
  loading: false,

  //  顧客初期データ
  constData: {
    member_group: [],
    ages: {},
    total_display_category: [],
    catd_kind: [],
    payment_method: []
  },
  //  顧客分析再現パラメータ
  condition: {
  },
  //  デフォルト条件（normalizeCondition適用済み）
  defaultCondition: {
  }
}

const getters = {
  getAnalyzeCondition (state) {
    let analyzeCondition = _.cloneDeep(state.condition)

    return analyzeCondition
  }
}

const actions = {
  setConstData ({ commit }, payload) {
    commit('setConstData', payload)
  },
  setCondition ({ commit }, payload) {
    commit('setCondition', payload)
  },
  setDefaultCondition ({ commit }, payload) {
    commit('setDefaultCondition', payload)
  }
}

const mutations = {
  setIsInit (state, data) {
    state.isInit = data
  },
  setLoading (state, data) {
    state.loading = data
    if (data) {
      this.dispatch('loading/loadingPagePlus')
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  setConstData (state, data) {
    Object.keys(state.constData).forEach(
      key => {
        if (key in state.constData) {
          state.constData[key] = data[key]
        } else {
          state.constData[key] = []
        }
      }
    )
    //  site情報から初期データ読み込み
    state.constData.rank_definision = Constants.getSite('rank_definision')
    state.constData.catd_kind = Constants.getSite('card_kind')
    state.constData.payment_method = Constants.getSite('payment_method')
  },
  setCondition (state, data) {
    state.condition = data
  },
  setDefaultCondition (state, data) {
    state.defaultCondition = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
